module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNjExNzU5ZGNhNTE2ODdjNTVkMjZlODE4Y2FmMDE1N2QucG5nIjs="